/**
 * Release flags for capabilities the live backend does not provide yet.
 * Both default OFF and are opt-in via env, so a build never advertises a flow its backend has switched off.
 *
 * These are BUILD-time values: Vite inlines `import.meta.env.VITE_*` into the bundle. Changing one
 * means editing the matching `.env.<mode>` file (`.env.production` for `npm run build` /
 * `deploy:prod`, `.env.uat` for `npm run build:uat` / `deploy:uat`) and rebuilding + redeploying.
 * Restarting or re-deploying the backend does not change what a deployed bundle shows.
 */

/**
 * Manual bKash payment page (member sends money in the bKash app, then submits the TrxID for admin
 * verification via POST /payments/bkash/submit). Mirrors the backend `BKASH_MANUAL_ENABLED` runtime flag, which
 * answers 404 FEATURE_DISABLED when off. On in `.env.uat`, off in production. The old redirect checkout
 * (E11/E12) is not built.
 */
export const BKASH_ENABLED = import.meta.env.VITE_ENABLE_BKASH === 'true';

/** bKash number members send money to, and the bKash mode they use (display-only config). */
export const BKASH_PAY_NUMBER = import.meta.env.VITE_BKASH_PAY_NUMBER || '01915209811';
export const BKASH_PAY_MODE = import.meta.env.VITE_BKASH_PAY_MODE || 'Payment';

/**
 * Withdrawals accept new requests. Mirrors the backend `WITHDRAWALS_ENABLED` kill-switch, which is a
 * runtime flag on the API (the backend OTP SMS is sent after commit and its outcome recorded). The two
 * are independent: turn the backend on first, then ship a webapp build with this on; to stop, flip the
 * backend flag (immediate) and then rebuild without this one. History remains readable either way.
 * Rollout order and parity table: sristi-green-backend/docs/deploy/WITHDRAWALS_ROLLOUT.md.
 */
export const WITHDRAWALS_ENABLED = import.meta.env.VITE_WITHDRAWALS_ENABLED === 'true';

/** Path members are sent to when they want to pay and bKash is not offered. */
export const PAY_FALLBACK_PATH = '/payments/bank-slip/upload';

/**
 * Self-service forgot-password (E30–E32). Mirrors the backend `PASSWORD_RESET_ENABLED` flag, which answers
 * 404 FEATURE_DISABLED when off. A function, not a constant, so the login link follows the flag at render time.
 * Turn the backend on first, then ship a build with `VITE_PASSWORD_RESET_ENABLED=true`.
 */
export function isPasswordResetEnabled(): boolean {
  return import.meta.env.VITE_PASSWORD_RESET_ENABLED === 'true';
}
